import { z } from 'zod'

/** Public Vite client env for ops console (#576). Secrets stay on the API Worker. */
const parsed = z
  .object({
    VITE_API_URL: z.string().url().default('http://localhost:8787'),
    VITE_PRODUCT_URL: z.string().url().default('http://localhost:5173'),
  })
  .parse(import.meta.env)

export const env = {
  apiUrl: parsed.VITE_API_URL,
  productUrl: parsed.VITE_PRODUCT_URL,
} as const
